import { useAtomCallback } from "jotai/utils"
import {
  beginAtom,
  currentDurationAtom,
  currentTimeAtom,
  endAtom,
  isLoopEnabledAtom,
} from "../state"

export default function usePlaybackUpdate() {
  return useAtomCallback(
    (get, set, elm: HTMLVideoElement | HTMLAudioElement) => {
      const begin = get(beginAtom)
      const end = get(endAtom)
      const currentDuration = get(currentDurationAtom)
      const isLoopEnabled = get(isLoopEnabledAtom)

      const currentTime = elm.currentTime
      set(currentTimeAtom, currentTime)
      if (currentTime < (begin || 0)) {
        elm.currentTime = begin || 0
      } else if (currentTime > (end || currentDuration || 0)) {
        if (isLoopEnabled) {
          elm.currentTime = begin || 0
          elm.play()
        } else {
          elm.pause()
        }
      }
    }
  )
}
